import PinVerification from './PinVerification';

export default PinVerification;